module.exports = __webpack_public_path__ + "static/media/loveReadings.d523f8a5.png";